import { Category } from 'shared/types/product';
import { NavigationMenuItem } from '..';
import { LinkReference, PageFolderReference } from 'types/reference';
import { MenuItem } from 'components/commercetools-ui/organisms/header/types';

const isCategory = (item: Category | NavigationMenuItem): item is Category =>
  typeof (item as Category).categoryId !== 'undefined' && 'depth' in item;

const isLinkReference = (link: any): link is LinkReference => link?.type === 'link' && typeof link.link === 'string';

const isPageFolderReference = (link: any): link is PageFolderReference =>
  link?.type === 'page-folder' && typeof link.pageFolder === 'object';

export const normalizeMenuItems = (navItems: Array<Category | NavigationMenuItem> = []): MenuItem[] => {
  return navItems.map((item, key) => {
    const isCat = isCategory(item);

    const descendantsArr = item.descendants || [];

    let link = '';
    if (!isCat && item.link) {
      if (isPageFolderReference(item.link)) {
        // Prefer default locale, fallback to _url
        link = item.link.pageFolder._urls?.default || item.link.pageFolder._url || '';
      } else if (isLinkReference(item.link)) {
        link = item.link.link || '';
      }
    } else if (isCat) {
      link = (item as Category)._url || (item as Category).slug || '';
    }

    // Determine name value
    let name = '';
    if (isCat) {
      name = item?.name || '';
    } else if ('label' in item && typeof item.label === 'string') {
      name = item?.label;
    }

    return {
      id: isCat
        ? (item.categoryId ?? key) // fallback to key if categoryId is undefined
        : key,
      name: name,
      link: link,
      openInNewWindow: Boolean(
        !isCat && (isLinkReference(item.link) || isPageFolderReference(item.link)) ? item.link.openInNewWindow : false,
      ),
      isCategory: isCat,
      descendants: descendantsArr.length ? normalizeMenuItems(descendantsArr) : [],
    };
  });
};
